import React, { useEffect } from 'react';
import 'components/customComponents/Layers/SelectIngredients.scss';
import Explorer, { TreeControlState } from 'components/explorer';
import ELayersView from 'enums/ELayersView';
import { withTabBackButton, WithTabBackButtonStateProps } from 'components/tab';
import TreeDataSupplier from 'business/tree/TreeDataSupplier';
import ETreeNodeTypes from 'enums/ETreeNodeTypes';

interface SelectFragmentTreePathProps extends WithTabBackButtonStateProps {
  setParentNode: (...args) => void;
  treeControlState: TreeControlState;
  setTreeControlState: (state: TreeControlState) => void;
  handleOnNodeSelect: (...args) => any;
  handleBackToPreviousScreen: (contentView: ELayersView) => () => void;
}

const exludedNodesList = [
  ETreeNodeTypes.Screen,
  ETreeNodeTypes.ScreensFolder,
  ETreeNodeTypes.Screens,
  ETreeNodeTypes.SearchAnalysis,
  ETreeNodeTypes.QuickAccess,
  ETreeNodeTypes.SynchrotronTripv4,
  ETreeNodeTypes.SynchrotronTripv4Folder,
  ETreeNodeTypes.CrystalTrackv4,
  ETreeNodeTypes.Searches,
  ETreeNodeTypes.RecycleBin,
];

const SelectFragmentTreePath = (props: SelectFragmentTreePathProps) => {
  const {
    setParentNode,
    handleBackToPreviousScreen,
    treeControlState,
    setTreeControlState,
    handleOnNodeSelect,
    setHandleOnTabBackPress,
  } = props;

  useEffect(() => {
    setHandleOnTabBackPress(() =>
      handleBackToPreviousScreen(ELayersView.SELECTFRAGMENTSCREEN),
    );
  }, [setHandleOnTabBackPress]);

  const shouldRenderNode = (node) => {
    if (exludedNodesList.includes(node.type)) {
      return null;
    }
    return node;
  };

  return (
    <div  id="commandpanel-selectfragmenttreepath-wrapper" className="select-ingredients-tabs">
      <Explorer
        showQuickAccessNode={false}
        setParentNode={setParentNode}
        dataSupplier={TreeDataSupplier}
        globalTreeNodes={{ treeNodes: [] }}
        commonTreeNodes={[]}
        gSelectedNode={0}
        treeControlState={treeControlState}
        setTreeControlState={setTreeControlState}
        onNodeSelect={handleOnNodeSelect}
        shouldRenderNode={shouldRenderNode}
      />
    </div>
  );
};

export default withTabBackButton(SelectFragmentTreePath);
